import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class CustomersDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private customersRef: any;
  public displayItems: any;

  /* @ngInject */
  constructor(private $customers, private $log) {
  }

  $onInit() {
    this.customersRef = this.$customers();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.customersRef.$asyncValues(ids)
        .then((customers) => {
          const displayItems = [];
          _.forEach(customers, (c) => {
            displayItems.push({id: c.id, value: `${c.firstName} ${c.lastName}`})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }



}

angular
  .module('bringoz.admin.customers')
  .component('customersDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./customers-display-list.html').default,
    controller: CustomersDisplayListComponent
  });
